goog.provide("shadow.js.shim.module$src$svg$artwork$error_svg$default");
shadow.js.shim.module$src$svg$artwork$error_svg$default = shadow.js.shim.module$src$svg$artwork$error_svg.default;
